module.exports = __webpack_public_path__ + "static/background-tutorials-6e1628b5155fa2d209dd74ea2487ee34.jpg";